<script lang="ts">
  import { get } from 'svelte/store';
  import AU from 'public-web-icons/dist/flags/AU.png';
  import CA from 'public-web-icons/dist/flags/CA.png';
  import ES from 'public-web-icons/dist/flags/ES.png';
  import FR from 'public-web-icons/dist/flags/FR.png';
  import GB from 'public-web-icons/dist/flags/GB.png';
  import IE from 'public-web-icons/dist/flags/IE.png';
  import JP from 'public-web-icons/dist/flags/JP.png';
  import US from 'public-web-icons/dist/flags/US.png';
  import { localizedCountryNamesStore } from './store';
  import type { FlagIconProps } from './types';

  export let countryCode: FlagIconProps['countryCode'];

  const srcMap: Record<Uppercase<FlagIconProps['countryCode']>, string> = {
    AU,
    CA,
    ES,
    FR,
    GB,
    IE,
    JP,
    US,
  };

  const src = srcMap[countryCode.toUpperCase() as Uppercase<FlagIconProps['countryCode']>];

  $: alt = get(localizedCountryNamesStore)[countryCode] || countryCode.toUpperCase();
</script>

<img {src} {alt} loading="lazy" />

<style lang="scss">
  @layer standard-components {
    img {
      display: inline-block;
      height: 18px;
      width: 32px;
    }
  }
</style>
